"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSafeTSAccountProtection = void 0;
var _riskidReactjsTs = require("@transmitsecurity/riskid-reactjs-ts");
var useSafeTSAccountProtection = exports.useSafeTSAccountProtection = function useSafeTSAccountProtection() {
  try {
    // Attempt to call the hook
    return (0, _riskidReactjsTs.useTSAccountProtection)();
  } catch (error) {
    // If the provider is not available, return a fallback implementation
    return {
      triggerActionEvent: function triggerActionEvent() {
        return Promise.resolve();
      },
      // No-op function
      setAuthenticatedUser: function setAuthenticatedUser() {
        return Promise.resolve();
      },
      clearUser: function clearUser() {
        return Promise.resolve(false);
      }
    };
  }
};